import { FunctionComponent, ReactElement } from "react";
import { Steps } from "antd";
import { ReactComponent as StepDone } from "src/static/icons/icon-step-finish.svg";
import { ReactComponent as StepCurrent } from "src/static/icons/icon-step-current.svg";
import { ReactComponent as StepWaiting } from "src/static/icons/icon-step-wait.svg";
import { useViewport } from "@utils/breakpoints-helper";
import BasicCard from "@components/cards/BasicCard";

const { Step } = Steps;

interface StepProps {
  title: string;
}

interface StepperProps {
  steps?: StepProps[];
  breakpoint?: number;
  current?: number;
}

const Stepper: FunctionComponent<StepperProps> = ({
  steps = [],
  breakpoint = 768,
  current = 0,
}) => {
  const { width } = useViewport();

  const getStepElement = (step: StepProps, index: number): ReactElement => {
    let icon: ReactElement;
    let status: "wait" | "process" | "finish" | "error" | undefined = undefined;
    if (index === current) {
      icon = <StepCurrent aria-hidden="true" focusable="false" />;
      status = "process";
    } else if (index < current) {
      icon = <StepDone aria-hidden="true" focusable="false" />;
      status = "finish";
    } else {
      icon = <StepWaiting aria-hidden="true" focusable="false" />;
      status = "wait";
    }
    return <Step key={index} title={step.title} icon={icon} status={status} />;
  };

  return (
    <BasicCard className="card-stepper">
      <Steps
        direction={width >= breakpoint ? "horizontal" : "vertical"}
        labelPlacement={width >= breakpoint ? "vertical" : "horizontal"}
      >
        {steps.map((step: StepProps, index: number) => {
          return getStepElement(step, index);
        })}
      </Steps>
    </BasicCard>
  );
};

export default Stepper;
